class globalScript {
  constructor() {
    this.init()
  }

  async init() {
    await this.aos()
  }

  async aos(){
    const { default: AOS } = await import(
      /* webpackChunkName: 'AOS' */ 'aos'
    )
    AOS.init()
  }
}

export default new globalScript()
